<template>
  <md-list-item @click="isFormOpened = !isFormOpened">

    <span class="settings__item-text text_large">{{i18n.set_change_password() }}</span>
    <md-icon class="md-icon--half-sized">keyboard_arrow_right</md-icon>

    <md-dialog class="change-password__dialog settings-dialog" :md-active.sync="isFormOpened" :md-click-outside-to-close="!isPending">
      <md-progress-bar md-mode="indeterminate" v-if="isPending"/>
      <div class="text_large">{{ i18n.set_change_password() }}</div>
      <form novalidate @submit.prevent="submit">
        <div class="settings-dialog__content">
          <input-field
            v-model="form.password"
            id="settings-password"
            name="password"
            type="password"
            :togglePassword="true"
            :label="i18n.lbl_new_pwd()"
            :errorMessage="errorMessage('password')"
            :data-vv-as="i18n.signup_password()"
            v-validate="'required|min:6'"
          />
          <input-field
            v-model="form.confirmPassword"
            id="settings-confirm-password"
            name="confirm-password"
            type="password"
            :label="i18n.lbl_pwd_confirm()"
            v-validate="'required'"
            :errorMessage="pwdUnconfirmedMessage"
          />
        </div>

        <div class="btn-wrap space-between margin-top">
          <md-button type="button" class="btn md-primary" :disabled="isPending" @click="isFormOpened = !isFormOpened">
            {{i18n.lbl_cancel() }}
          </md-button>
          <md-button type="submit" class="btn md-primary" :disabled="isPending">
            {{ i18n.lbl_submit() }}
          </md-button>
        </div>
      </form>
    </md-dialog>
  </md-list-item>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import { authService } from '@api/auth.service'
  import { vuexTypes } from '@vuex/types'
  import { i18n } from '@js/i18n'

  import Form from '@com/mixins/form.mixin'

  export default {
    name: 'change-password',
    mixins: [Form],
    data: _ => ({
      isFormOpened: false,
      i18n,
      form: {
        password: '',
        confirmPassword: ''
      }
    }),
    computed: {
      ...mapGetters([
        vuexTypes.userEmail,
        vuexTypes.accountId
      ]),
      pwdUnconfirmedMessage () {
        return (this.form.password && this.form.confirmPassword &&
                this.form.confirmPassword !== this.form.password)
               ? i18n.set_pwd_do_not_match() : ''
      }
    },
    methods: {
      ...mapActions({
        storeNewData: vuexTypes.STORE_USER_DATA_FROM_WALLET
      }),
      async submit () {
        if (!await this.isValid()) return
        if (this.pwdUnconfirmedMessage) return
        this.disable()
        try {
          const newKeys = await authService.changePassword({
            email: this.userEmail,
            newPassword: this.form.password
          })
          EventDispatcher.dispatchShowSuccessEvent(i18n.set_pwd_changed())
          this.isFormOpened = false
          this.storeNewData({
            publicKey: newKeys.newPublicKey,
            walletId: newKeys.newWalletId,
            seed: newKeys.newSeed,
            accountId: this.accountId,
            email: this.userEmail
          })
        } catch (error) {
          const err = await error
          if (err.status && err.title) {
            EventDispatcher.dispatchShowErrorEvent(err.title + ' (' + err.status + ')')
          } else if (err.message) {
            EventDispatcher.dispatchShowErrorEvent(err.message)
          } else if (error.showBanner) {
            error.showBanner(i18n.unexpected_error())
          } else {
            EventDispatcher.dispatchShowErrorEvent(i18n.unexpected_error())
          }
        }
        this.enable()
      }
    },
    watch: {
      isFormOpened () {
        this.form.password = ''
        this.form.confirmPassword = ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './settings.scss';
</style>



// WEBPACK FOOTER //
// src/vue/app/settings/security/Security.ChangePassword.vue